<template>
  <div>
    <div :class="frameClasses">
      <fragment v-if="hasNoStepperStep">
        <div class="timeline-item-deadline">{{ deadlineDate }}</div>
      </fragment>
      <fragment v-if="isFulfilled && !hasNoStepperStep">
        <div class="timeline-item-vertical-line-2"></div>
        <div class="timeline-item-deadline">{{ deadline }} hora(s)</div>
        <div class="timeline-item-button" v-if="showButton">
          <button
            class="jns-button yellow-button flex ml-0 mb-4"
            @click="$emit('action-button')"
          >
            {{ textButton }}
          </button>
        </div>
      </fragment>
      <fragment v-if="!isFulfilled && !hasNoStepperStep">
        <div class="timeline-item-vertical-line-2"></div>
        <div class="timeline-item-deadline">&nbsp;</div>
      </fragment>
    </div>
  </div>
</template>

<script lang="js">
import { formatDate } from "@/libs/utils";

export default {
  name: "TimelineItemBottom",
  props: [
    "status",
    "deadline",
    "isFulfilled",
    "hasNoStepperStep",
    "altDeadline",
    "showButton",
    "textButton",
  ],
  computed: {
    deadlineDate() {
      return formatDate(this.altDeadline);
    },
    frameClasses() {
      return {
	"timeline-item-container": true,
	"no-stepper-step": this.hasNoStepperStep
      };
    }
  }
};
</script>

<style lang="scss" scoped>
#jns {
  .no-stepper-step {
    .timeline-item-deadline {
      margin-top: 0px;
    }
  }
  .timeline-item-deadline {
    margin-top: 40px;
    padding-top: 20px;
    text-align: center;
    font-size: 12px;
    color: #061d45;
    position: relative;
    bottom: 11px;
  }
  .timeline-item-vertical-line-2 {
    border-left: 1px solid #d8d8d8;
    height: 25px;
    position: absolute;
    top: -30px;
    left: 50%;
  }

  .timeline-item-button {
    // width: 100%;
    // min-width: 24vh;
    // position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/TimelineItemBottom.vue